import { render, staticRenderFns } from "./automationComponentTypeBrowser.vue?vue&type=template&id=0f84f988&"
import script from "./automationComponentTypeBrowser.vue?vue&type=script&lang=js&"
export * from "./automationComponentTypeBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports